export enum DocumentAccessRole {
  SPONSOR = 'SPONSOR',
  FREELOADER = 'FREELOADER',
  ER_EE = 'ER_EE', // Employer/employee
}

export enum DocumentStatus {
  BYPASSED = 'BYPASSED',
  NOT_UPLOADED = 'NOT_UPLOADED',
  REJECTED = 'REJECTED',
  UPLOADED = 'UPLOADED',
  APPROVED = 'APPROVED',
  SIGNATURE_PENDING = 'SIGNATURE_PENDING',
  SIGNATURE_REQUEST_FAILED = 'SIGNATURE_REQUEST_FAILED',
  SIGNED = 'SIGNED',
  INACTIVE = 'INACTIVE',
}

export enum DocumentAction {
  BYPASS = 'BYPASS',
  DISCARD = 'DISCARD',
  REMOVE_UPLOAD = 'REMOVE_UPLOAD',
  DOWNLOAD = 'DOWNLOAD',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  EDIT = 'EDIT',
  EDIT_TEMPLATE = 'EDIT_TEMPLATE',
  REQUEST_FOR_SIGNATURE = 'REQUEST_FOR_SIGNATURE',
  SEND_SIGN_REMINDER = 'SEND_SIGN_REMINDER',
  CHANGE_SIGNATURE_EMAIL = 'CHANGE_SIGNATURE_EMAIL',
}

export interface ActionContext {
  ui: {
    showSentNotification(): void;
    showBeError(error: string): void;
    openEditModal?: () => void;
    openEditTemplateModal?: () => void;
    openRequestSignModal?(): void;
  };
  interactions: {
    refreshData: () => Promise<void>;
    setCardIsLoading(status: boolean): void;
    setPageIsLoading(status: boolean): void;
  };
  static: {
    documentId: string;
  };
}

export interface ActionObject {
  type: DocumentAction;
  name: string;
  /* Show in the list */
  showForRoles: DocumentAccessRole[] | null;
  /* Controls isDisabled flag */
  enableForRoles: DocumentAccessRole[] | null;
  showForStatuses: DocumentStatus[] | null;
  hideOnPages: UploadStep[] | null;
  handler: (context: ActionContext) => Promise<void> | void;
  isDisabled?: boolean;
}

export interface DocumentDomainProperties {
  excludeActions: DocumentAction[];
}

export interface ActionUiPresenter {
  type: DocumentAction;
  name: string;
  isDisabled?: boolean;
  handler: () => Promise<void>;
}

export interface Uploader {
  id: string;
  name: string;
  creationDateTime: string;
}

export enum FileSource {
  SYSTEM_GENERATED = 'SYSTEM_GENERATED',
  CUSTOM = 'CUSTOM',
  POLICY = 'POLICY',
}

export interface Document {
  id: string;
  status: DocumentStatus;
  uploader: Uploader | null;
  filePath: string;
  active: boolean;
  type: string; // Title of the document.
  description: string;
  templateLink: string;
  eligibleForSignature: boolean;
  fileSource: FileSource;
  restrictions?: DocumentsRestrictions;
}

export enum UploadStep {
  CHECKLIST = 'CHECKLIST',
  INITIATE_RFQ = 'INITIATE_RFQ',
  RFQ_PROPOSAL = 'RFQ_PROPOSAL',
  MAINTAIN = 'MAINTAIN',
  POST_SUBMIT = 'POST_SUBMIT',
  RFQ_RESPONSE = 'RFQ_RESPONSE',
  SUBSCRIBER_IMQ = 'SUBSCRIBER_IMQ',
}

export type DocumentsRestrictions = {
  [K in UploadStep]: DocumentRestriction;
};

export enum DocumentRestriction {
  BYPASS_ALLOWED = 'BYPASS_ALLOWED',
  UPLOAD_REQUIRED = 'UPLOAD_REQUIRED',
  APPROVE_REQUIRED = 'APPROVE_REQUIRED',
}

export type DocUploadStrategy = 'PREDEFINED_DOC' | 'CUSTOM_DOC';

export enum UserAction {
  REJECT = 'REJECT',
  APPROVE = 'APPROVE',
  BYPASS = 'BYPASS',
}

export interface Recipient {
  name: string;
  email: string;
}
